import { Button, Tab, TabProps, Theme, styled } from '@mui/material';
import { Link, To } from 'react-router-dom';
import { ReactNode } from 'react';
import { createStyles, makeStyles } from '@mui/styles';

import { PoolBadge } from '../badge/pool-badge';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tabRoot: {
            textTransform: 'none',
            color: theme.palette.text.primary,
            '&.Mui-selected': {
                color: theme.palette.text.primary,
            },
            '&:hover': {
                backgroundColor: theme.palette.grey[100],
            },
        },
        badgeRoot: {
            flexDirection: 'row-reverse',
            alignItems: 'center',
        },
        badge: {
            top: 0,
            right: 0,
            position: 'relative',
            marginRight: theme.spacing(),
        },
    })
);

const StyledPoolBadge = styled(PoolBadge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        marginRight: theme.spacing(1),
    },
}));

export interface PoolTabOwnProps {
    badge?: ReactNode;
    linkTo?: To;
}

export type PoolTabProps = PoolTabOwnProps & TabProps;

export const PoolTab = (props: PoolTabProps) => {
    const classes = useStyles();

    const { label, badge, linkTo, ...rest } = props;

    return (
        <Tab
            component={linkTo ? Link : Button}
            to={linkTo}
            classes={{ root: classes.tabRoot }}
            label={<StyledPoolBadge content={badge}>{label}</StyledPoolBadge>}
            // Type of rest diverges from TabProps if 'component' is set
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            {...(rest as any)}
        />
    );
};
